/**
 * Check for mobile user agents
 * @return boolean
 */
export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

/**
 * Check for small (tailwind .md) screen sizes
 * @return boolean
 */
export function isMobileMq() {
  return !window.matchMedia("(width >= 48rem)").matches
}

export function getContainerQueryElement(element?: HTMLElement | null) {
  let parent = element?.parentElement ?? null

  // Tailwind container queries are scoped by the nearest parent with the literal @container class.
  while (parent && !parent.classList.contains("@container")) {
    parent = parent.parentElement
  }

  return parent
}

/**
 * Check for small (tailwind @md) container sizes, needs to have a parent @container class.
 * @return boolean
 */
export function isMobileContainerMq(element?: HTMLElement | null) {
  const container = getContainerQueryElement(element)
  if (!container) return false

  const rem = parseFloat(getComputedStyle(document.documentElement).fontSize)
  return container.getBoundingClientRect().width < 28 * rem
}

/**
 * Check if the app is a PWA (or TWA)
 * @return boolean
 */
export function isPWA() {
  const displayModes = ["fullscreen", "standalone", "minimal-ui"]
  return (
    displayModes.some(
      (displayMode) => window.matchMedia("(display-mode: " + displayMode + ")").matches
    ) || document.referrer.includes("android-app://")
  )
}
